import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import LcIcon from "../LcIcon";
import LcIconLink from "../LcIconLink";
import "./index.css"

interface Props {
    row: any
}

const RequesterDisplay: React.FC<Props> = (props) => {
    const [toggle, setToggle] = useState<boolean>(false);
    const history = useHistory();
    const handleClickQuery = (type) => {
        history.push(`/Attendance/${props.row.id}?activeTab=2&type=${type}&idWork=${props.row.idWork}`);
    }

    return (
        <div style={{ display: "flex", flexDirection: "row", flexWrap: "nowrap", alignItems: "center" }}>
            {
                (props.row.nameResponsibleUser === "Sem atendente")
                    ? <div className={"responsible"}>
                        <LcIconLink icon={"ppi ppi-clock"} size={"small"} color={"#898da6"} activedAfterClick={toggle} onClick={() => setToggle(!toggle)} />

                        <div className={(toggle) ? "active icons actions" : "icons"} >
                            <LcIconLink icon={"ppi ppi-play"} size={"small"} tooltip={"Iniciar Trabalho"} onClick={() => handleClickQuery(0)} />
                            <LcIconLink icon={"ppi ppi-switch-horizontal"} size={"small"} tooltip={"Transferir Trabalho"} onClick={() => handleClickQuery(2)} />
                        </div>
                    </div>

                    : <div className={"responsible"}>
                        <LcIcon icon={"ppi ppi-user"} size={"small"} color={"#141B4D"} />
                        <span style={{
                            maxWidth: "150px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkiBox",
                            lineHeight: "36px",
                            maxHeight: "36px",
                            WebkitLineClamp: "1",
                            WebkitBoxOrient: "vertical",
                            paddingRight: "20px"
                        }}
                        > {props.row.nameResponsibleUser} </span>
                    </div>
            }
        </div>
    )
}

export default RequesterDisplay;